import { FilledPrimaryBtn, FilledWhiteBtnLink } from "./FilledBtn";
import { WhiteOutlineBtnLink } from "./OutlineBtn";
import NativeLazyImage from "./NativeLazyImage";
import HorizonalCheckLine from "./HorizonalCheckLine";

import "./../styles/HeroBanner3.style.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faFacebookF,
  faInstagram,
  faLinkedinIn,
  faTwitter,
  faYoutube,
} from "@fortawesome/free-brands-svg-icons";
import { faEnvelope } from "@fortawesome/free-solid-svg-icons";
import { useNavigate } from "react-router-dom";

export default function HeroBanner3({ title, desc }) {
  const backgroundStyle = {
    backgroundImage: "url('/img/hero-background.jpg')",
    backgroundRepeat: "no-repeat",
    backgroundSize: "cover",
  };

  const navigateTo = useNavigate();

  return (
    <section
      className="hero py-5 hero-3 d-flex align-items-center"
      style={backgroundStyle}
    >
      <div className="container" style={{ maxWidth: "90%" }}>
        <div className="row align-items-center">
          <div className="col-lg-6 d-flex align-items-center">
            <div className="mb-5">
              <h1 className="text-white mb-2 mt-lg-2 mt-xl-0 text-center text-uppercase">
                Indian Academy of Law and Management
              </h1>

              <div className="d-flex justify-content-center mt-3 mb-lg-0">
                {/* <a
                  href="https://twitter.com/IndiaAcademyLaw"
                  target="_blank"
                  className="social-icons text-decoration-none mx-2"
                  rel="noreferrer noopener"
                  style={{ backgroundColor: "#1DA1F2" }}
                >
                  <FontAwesomeIcon icon={faTwitter} className="" />
                </a> */}

                <a
                  href="https://www.linkedin.com/company/indian-academy-of-law-&-management/?viewAsMember=true&original_referer=http%3A%2F%2Fialm.paybevdev.com%2F"
                  target="_blank"
                  className="social-icons text-decoration-none mx-2"
                  rel="noreferrer noopener"
                  style={{ backgroundColor: "#0077B5" }}
                >
                  <FontAwesomeIcon icon={faLinkedinIn} className="" />
                </a>

                <a
                  href="https://www.facebook.com/61587367055679/"
                  target="_blank"
                  className="social-icons text-decoration-none mx-2"
                  rel="noreferrer noopener"
                  style={{ backgroundColor: "#3B5998" }}
                >
                  <FontAwesomeIcon icon={faFacebookF} className="" />
                </a>

                <a
                  href="https://www.instagram.com/ialm_academy?utm_source=ig_web_button_share_sheet&igsh=ZDNlZDc0MzIxNw=="
                  target="_blank"
                  className="social-icons text-decoration-none mx-2"
                  rel="noreferrer noopener"
                  style={{
                    background: "#833ab4",
                    backgroundImage: `linear-gradient(to right, #833ab4,#fd1d1d,#fcb045)`,
                  }}
                >
                  <FontAwesomeIcon icon={faInstagram} className="" />
                </a>

                <a
                  href="mailto:registrar@ialm.academy"
                  target="_blank"
                  className="social-icons text-decoration-none mx-2"
                  rel="noreferrer noopener"
                  style={{ backgroundColor: "#d44638" }}
                >
                  <FontAwesomeIcon icon={faEnvelope} className="" />
                </a>
                <a
                  href="https://www.youtube.com/c/IALMcampus"
                  target="_blank"
                  className="social-icons text-decoration-none mx-2"
                  rel="noreferrer noopener"
                  style={{ backgroundColor: "#FF0000" }}
                >
                  <FontAwesomeIcon icon={faYoutube} className="" />
                </a>
              </div>

              <button
                type="button"
                onClick={() => {
                  navigateTo("/register");
                }}
                class="btn btn-light theme-btn bg-light mt-3 text-white text-white d-flex justify-content-center align-items-center btn btn-primary mx-auto mt-4 rounded-5"
              >
                Join for free
              </button>
            </div>
          </div>
          <div className="col-lg-6">
            <div
              style={{
                backgroundColor: "#C8FBFE",
                backgroundImage: "url('/img/text-bg.jpg')",
                backgroundSize: "cover",
                backgroundRepeat: "no-repeat",
              }}
              className="p-2 p-md-4"
            >
              <h2 className="text-dark bg-white rounded-3 p-1 fw-600 content-title mb-4">
                6 Reasons To Take IALM Courses
              </h2>

              <HorizonalCheckLine
                list={[
                  "Improve Knowledge, Skills and Education",
                  "Earn Globally Recognised Certifications (by ISO 9001:2015 certified  Institution)",
                  "Race Ahead in Indian Competitive Examinations",
                  "Increase Credits to apply to Foreign Universities",
                  "Get recommendations from Highly acclaimed IALM faculty",
                  "Get into the prestigious IALM Placement cell",
                ]}
              />
            </div>
            {/* <NativeLazyImage src="/img/slides/slide.png" classes="img-fluid" /> */}
          </div>
        </div>
      </div>
    </section>
  );
}
